// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import ErrorPageTemplate from 'presentations/views/components/templates/ErrorPageTemplate';
import MainDocument from 'presentations/views/components/MainDocument';
import Button from 'presentations/views/components/atoms/Button';
import styled from '@emotion/styled';
import { spacing, fontWeight, fontSize } from 'presentations/views/styles';
import { homePath } from 'presentations/routes/path';

interface Props {
  statusCode?: number;
}
export default function Component(props: Props) {
  const t = translateInComponent(translations);
  const titleKey = `title_${props.statusCode}`;
  let title = t(titleKey);
  if (title === titleKey) title = t('defaultTitle');

  const descKey = `description_${props.statusCode}`;
  let description = t(descKey);
  if (description === descKey) description = t('defaultDescription');

  return (
    <MainDocument title={title} description={description} isNoIndex={true}>
      <ErrorPageTemplate>
        <Error>
          <Status>{props.statusCode}</Status>
          <Title>{title}</Title>
          <Description>{description}</Description>

          <ButtonContainer>
            <Button href={homePath()} color="primary">
              {t('Back to Top page')}
            </Button>
          </ButtonContainer>
        </Error>
      </ErrorPageTemplate>
    </MainDocument>
  );
}

const Error = styled.div`
  text-align: center;
`;
const Status = styled.div`
  font-size: 64px;
  font-weight: ${fontWeight('bold')};
`;
const Title = styled.div`
  font-size: ${fontSize(18)};
  font-weight: ${fontWeight('bold')};
  margin-top: ${spacing(24)};
`;
const Description = styled.div`
  margin-top: ${spacing(8)};
`;

const ButtonContainer = styled.div`
  margin-top: ${spacing(32)};
`;
